import { AfterViewInit, Component, ElementRef, ViewChild } from '@angular/core';
import { NgClass } from '@angular/common';
import { TooltipPosition } from '../../../../core/directives/tooltip';

@Component({
  selector: 'app-custom-tooltip',
  templateUrl: './custom-tooltip.component.html',
  imports: [NgClass],
})
export class TooltipComponent implements AfterViewInit {
  position: TooltipPosition = TooltipPosition.BELOW;
  tooltip: string = '';
  left: number = 0;
  top: number = 0;
  visible: boolean = false;
  tooltipWidth: number = 250;

  @ViewChild('tooltipContainer') tooltipContainer!: ElementRef;

  ngAfterViewInit(): void {
    if (this.tooltipContainer) {
      this.tooltipContainer.nativeElement.style.top = this.top + 'px';
      this.tooltipContainer.nativeElement.style.left = this.left + 'px';
      this.tooltipContainer.nativeElement.style.maxWidth = this.tooltipWidth + 'px';
      const maxSizeOfTooltip = 250;
      if (this.tooltipContainer.nativeElement.scrollWidth > maxSizeOfTooltip) {
        this.tooltipContainer.nativeElement.classList.add('force-wrap');
      } else {
        this.tooltipContainer.nativeElement.classList.remove('force-wrap');
      }
    }
  }
}
